import { CommonModule } from '@angular/common';
import { Component, input, OnDestroy, inject } from '@angular/core';
import { DrawerConfig } from './drawer-config';
import { DrawerService } from './drawer.service';
import { BetaComponent } from '../ux/components/beta/beta.component';

/**
 * Component that wraps the MatDrawer component and dynamically injects the intended drawer component from drawer configuration.
 */
@Component({
  selector: 'app-mat-drawer-wrapper',
  imports: [CommonModule, BetaComponent],
  templateUrl: './mat-drawer.component.html',
  styleUrl: './mat-drawer.component.scss',
})
export class MatDrawerWrapperComponent implements OnDestroy {
  private readonly drawerService = inject(DrawerService);

  config = input<DrawerConfig>();

  ngOnDestroy() {
    this.drawerService.initDrawerSetup();
  }

  close() {
    this.drawerService.close();
  }
}
